import { FilterType } from '@/coreDomainsModule/entities/filter';
import { convertIDateToDateFormat, convertUnixTimeToIDate } from '../BaseTableContent/utils/dateFormat';
import { i18n } from '@/i18n';
import { FilterService } from '@/coreDomainsModule/services/filterService';
import { UNASSIGNED_COLUMN } from '@/coreDomainsModule/constants';

/**
 * SelectInputのViewModel
 */
export class SelectInputViewModel {
  private t: typeof i18n.t;

  /**
   * コンストラクタ
   */
  constructor() {
    this.t = i18n.t;
  }
  /**
   * 選択肢項目の表示用
   * @param filterKey - フィルターキー
   * @param value - 値
   */
  public displayValue = (filterKey: FilterType, value: string): string => {
    switch (filterKey) {
      case 'ORDER_DATE':
      case 'DESIRED_DELIVERY_DATE':
      case 'DELIVERY_DATE':
        return convertIDateToDateFormat(convertUnixTimeToIDate(Number(value)));
      case 'MANUFACTURER':
      case 'END_USER':
      case 'ORDER_PACKAGE':
      case 'ORDER_NUMBER':
      case 'ORDER_GROUP_NAME':
      case 'INVOICE_NUMBER':
      case 'DESTINATION_NAME':
      case 'PURCHASE_UNIT_PRICE':
      case 'SALES_UNIT_PRICE':
      case 'UNMATCHED_SUPPLIER_NUMBER':
      case 'UNMATCHED_SUPPLIER_NAME':
      case 'UNMATCHED_BUSINESS_NUMBER':
      case 'UNMATCHED_BUSINESS_NAME':
      case 'UNMATCHED_WAREHOUSE_NUMBER':
      case 'UNMATCHED_WAREHOUSE':
      case 'UNMATCHED_ORDER_NUMBER':
      case 'UNMATCHED_ORDER_ISSUED_NUMBER':
      case 'AGGREGATE_FREE_COLUMN':
      case 'BASE_FREE_COLUMN':
        return value === UNASSIGNED_COLUMN ? this.t(value) : value;
      case 'CUSTOMER_FORECAST_RESPONSIBLE_USER':
      case 'SUPPLIER_FORECAST_RESPONSIBLE_USER':
      case 'FORECAST_FOR_RECEIPT_RESPONSIBLE_USER':
      case 'FORECAST_TIMELINE_STAFF_NAME':
      case 'AGGREGATE_BUSINESS_GROUP_FILTER_INFO':
        // nameだけを表示
        return value === UNASSIGNED_COLUMN ? this.t(value) : value.split(',')[0];
      case 'ORDER_ID':
      case 'LEAD_TIME':
      case 'STANDARD_INVENTORY_INDEX_MIN':
      case 'STANDARD_INVENTORY_INDEX_MAX':
        const match = FilterService.separateStringValueAndUnit(value);
        if (match) {
          return match.value + this.t(match.unit);
        } else {
          return value;
        }
      case 'UNMATCHED_ACTION_TYPE':
        return this.t(value);
      default:
        return value;
    }
  };
}
